import { Spinner } from 'react-bootstrap';
import NumberInput from '../Input/NumberInput';
import SkillsMatrixDisplayField from './SkillsMatrixDisplayField';
import { formatUkDateFromString } from '../../utils/stringUtils';

const UserSkills = ({
  firstName,
  lastName,
  department,
  accessLevel,
  duty,
  setDuty,
  skillLevel,
  setSkillLevel,
  lastUpdated,
  loading,
}) => {
  return (
    <div className="p-3 bg-white skills-matrix">
      <div className="d-flex gap-5">
        <SkillsMatrixDisplayField label={'First Name'} value={firstName} loading={loading} />
        <SkillsMatrixDisplayField label={'Last Name'} value={lastName} loading={loading} />
      </div>

      <div className="d-flex gap-5 pt-3">
        <SkillsMatrixDisplayField label={'Department'} value={department} loading={loading} />
        <SkillsMatrixDisplayField label={'Access Level'} value={accessLevel} loading={loading} />
      </div>

      <div className="pt-4">
        <div className="input-label pb-1">Skill Level</div>
        <NumberInput value={skillLevel} onChange={setSkillLevel} min={0} max={99} disabled={loading} />
      </div>

      <div className="pt-4">
        <div className="input-label pb-1">Dutiable Jobs</div>
        <div>
          <input
            type="checkbox"
            onChange={(event) => setDuty(event.target.checked)}
            checked={duty}
            disabled={loading}
          />
        </div>
      </div>
      <div className="pt-4">
        <div className="input-label pb-1">Last Updated</div>
        <div className="minimum-height-field">
          {loading ? <Spinner animation="border" size="sm" /> : formatUkDateFromString(lastUpdated, true)}
        </div>
      </div>
    </div>
  );
};

export default UserSkills;
